// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"c2b00f18","787":"dcf93ac3"}[chunkId] + ".chunk.js";
};